import { render, staticRenderFns } from "./FilesRequestsEmptyState.vue?vue&type=template&id=77fc12bc&scoped=true"
import script from "./FilesRequestsEmptyState.vue?vue&type=script&lang=js"
export * from "./FilesRequestsEmptyState.vue?vue&type=script&lang=js"
import style0 from "./FilesRequestsEmptyState.vue?vue&type=style&index=0&id=77fc12bc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77fc12bc",
  null
  
)

export default component.exports